export default "__VITE_ASSET__2813511f__"